


























































import CreateModuleDialog from '@/components/Dialogues/CreateModuleDialog.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Module } from '@/interfaces/Module';
import axios from 'axios';
import env from '@/env';
import SelectAttribute from '@/components/Attributes/SelectAttribute.vue';
import AppSAPBadge from '@/components/App/AppSAPBadge.vue';

@Component({
  components: {
    AppSAPBadge,
    SelectAttribute,
    CreateModuleDialog
  }
})
export default class AttributesListDialog extends Vue {
  @Prop({ default: () => -1 })
  cutoverplanId!: number;

  @Prop()
  sap!: boolean;

  @Prop({ default: () => [] })
  modules!: Module[];

  dialog = false;

  new_name = '';

  blueprints: any[] = [];

  selectedBlueprints: number[] = [];

  showSelectAttributeOrigin = false;

  ask_user_queue: any[] = [];

  ask_user: any[] = [];

  filter = '';

  get selectableBlueprints() {
    const filteredModules: Module[] = this.blueprints
      .filter((blueprint: Module) => {
        if (!this.sap && blueprint.sap) return false;
        const selected = this.selectedBlueprints.includes(blueprint.id);
        if (selected) return selected;
        const inFilter = this.getModuleName(blueprint)
          ?.toLocaleLowerCase()
          .includes(this.filter.toLowerCase());
        return !!inFilter;
      })
      .sort((a: Module, b: Module) => this.getModuleName(a)?.localeCompare(this.getModuleName(b)));

    return filteredModules;
  }

  getModuleName(module: Module) {
    const preferredLanguage = module.moduleLanguages?.find(
      (language: any) => language.languageId === this.$store.state.user.languageId
    );
    console.log(module, preferredLanguage);
    return preferredLanguage?.name || module.moduleLanguages?.[0]?.name;
  }

  private blueprintIsAlreadyInCutoverplan(blueprintId: number) {
    return !!this.modules.find((module) => module.blueprint_id === blueprintId);
  }

  @Watch('dialog')
  onToggle(value: boolean) {
    if (value) this.$emit('open');
  }

  async created() {
    const { data } = await axios.get(`${env.backend_url}/module/blueprints/all`);
    this.blueprints = data;
  }

  async handleSelectBlueprintDialog() {
    const { selectedBlueprints } = this;
    this.dialog = false;

    if (selectedBlueprints.length < 1) return;

    for (const module_id of selectedBlueprints) {
      const { data }: any = await axios.post(
        `${env.backend_url}/modules/from_blueprint/${module_id}`,
        {
          id: this.cutoverplanId
        }
      );
      if (data.ask_user) {
        if (this.showSelectAttributeOrigin) {
          this.ask_user_queue.push(data.ask_user);
        } else {
          this.ask_user = data.ask_user;
          this.showSelectAttributeOrigin = true;
        }
      } else {
        const { id, name } = data;
        this.$store.commit('addModuleToModuleIdsToNameMap', { id, name });
        this.$emit('addedModule', data.id);
      }
    }
    this.$store.dispatch('refreshIdstoNameMap');
    this.selectedBlueprints = [];
  }

  async handleSelectAttributeDialog(chosen: any, moduleId: number) {
    this.showSelectAttributeOrigin = false;
    if (!chosen || !moduleId) {
      return;
    }

    const { data } = await axios.post(`${env.backend_url}/modules/from_blueprint/${moduleId}`, {
      id: this.cutoverplanId,
      chosen
    });
    this.$emit('addedModule', data.id);
    if (this.ask_user_queue.length > 0) {
      this.ask_user = this.ask_user_queue.shift();
      this.showSelectAttributeOrigin = true;
    }
  }
}
